import { Suspense, lazy } from "react";
import {
  RiFileList2Fill,
  RiLinkedinFill,
  RiMailOpenFill,
  RiTwitterXFill,
} from "react-icons/ri";
import Resume from "../assets/cv-final.pdf";
import MainGraphic from "../assets/main_graphic.png";
import OptimizedImage from "../components/OptimizedImage";

const MainSection = lazy(() => import("../components/MainSection"));

const social = [
  {
    icon: <RiMailOpenFill />,
    name: "Twitter",
    link: "mailto:shahidayan86@gmail.com",
  },
  {
    icon: <RiTwitterXFill />,
    name: "Twitter",
    link: "https://twitter.com/shahidayandev",
  },
  {
    icon: <RiLinkedinFill />,
    name: "Linkdin",
    link: "https://www.linkedin.com/in/ayaan-codes",
  },
];

const Home = () => {
  return (
    <div className="py-4 flex lg:flex-row flex-col items-start justify-between text-white px-4 font-mono">
      <div className="border w-full rounded-lg px-5 py-5 h-full border-zinc-600 flex-1">
        <div className="flex items-center justify-between lg:mx-5">
          <div className="lg:text-4xl text-xl font-bold">Ayaan</div>
          <div className="font-semibold font-mono">Full Stack Developer</div>
        </div>
        <div className="text-center">
          <div className="mt-16 flex justify-center">
            <OptimizedImage
              src={MainGraphic}
              alt="developer_photo"
              className="w-[350px] h-[350px] rounded-full"
              width={350}
              height={350}
              loading="eager"
            />
          </div>
          <div className="mt-16">shahidayan86@gmail.com</div>
          <div>Base in Hyderabad, India</div>
          <div className="text-xs my-5 text-gray-500">
            {new Date().getFullYear()} Ayaan. All rights reserved
          </div>
          <div className="mt-8 flex justify-center items-center">
            {social?.map((so) => {
              return (
                <a
                  key={so.link}
                  href={so.link}
                  target="_blank"
                  className="hover:bg-green-600 hover:text-white hover:cursor-pointer px-2 py-2 mr-3 rounded-full border-2"
                  rel="noreferrer"
                >
                  {so.icon}
                </a>
              );
            })}
          </div>
          <div className="flex items-center bg-green-600 mt-8 mx-5 rounded-full py-3 justify-center">
            <div className="mr-3">
              <RiFileList2Fill />
            </div>
            <a href={Resume} download>
              Download Resume
            </a>
          </div>
        </div>
      </div>
      <div></div>
      <div className="mx-2 mt-14 lg:px-8" style={{ flex: 2.5 }}>
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-64">
              <div className="w-8 h-8 border-2 border-gray-600 border-t-green-500 rounded-full animate-spin"></div>
            </div>
          }
        >
          <MainSection />
        </Suspense>
      </div>
    </div>
  );
};

export default Home;
